/**
 * Legacy React API shims. Import this first in app.js so it runs before any deps (router, react-toastr, react-bootstrap).
 * - React.PropTypes: removed in React 16; must be callable (react-router, react-bootstrap call validators directly).
 * - React.createClass: removed in React 17; react-toastr and other legacy libs need it.
 * Use prop-types factory with throwOnDirectAccess: false so PropTypes.string(props, key, component) works.
 */
import React from 'react';
import ReactIs from 'react-is';
import createPropTypesFactory from 'prop-types/factoryWithTypeCheckers';
import createReactClass from 'create-react-class';

const PropTypes = createPropTypesFactory(ReactIs.isElement, false);

if (!React.PropTypes) React.PropTypes = PropTypes;
if (!React.createClass) React.createClass = createReactClass;
